// extracted by mini-css-extract-plugin
module.exports = {"helsinkiCityOwnedSpan":"helsinkiCityOwnedIcon_helsinkiCityOwnedSpan__vbxWb","helsinkiCityOwnedIcon":"helsinkiCityOwnedIcon_helsinkiCityOwnedIcon__dl2DT"};